// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"_3B9hh","contentWrapper":"_3B9hh","page":"_2XczI","withNotificationBar":"_1hWA6","related-sites-and-search-ui":"Y83E9","relatedSitesAndSearchUi":"Y83E9"};